<template>
  <div class="myNewsDetails MYNewsDetails">
    <!-- 新闻详情 -->
    <van-nav-bar :title="title"
                 left-text
                 left-arrow
                 @click-left="onClickLeft"
                 :fixed="true" />
    <div class="content">
      <!-- 隐藏标题 -->
      <div class="title"
           v-if="false">
        <div class="name">{{news.newstitle}}</div>
        <div class="desc">
          <span>发布时间：{{news.crdate}}</span>
          <span>文字来源：{{news.crman}}</span>
          <span>点击量：{{news.readcount}}</span>
        </div>
      </div>
      <div ref="newHtml"
           class="newHtml"
           v-html="news.newsmemo"></div>
    </div>
  </div>
</template>

<script>
import { getNewsInfo, getScanEntryHomeSet } from '@/request/api.js'
import { ImagePreview } from 'vant';
export default {
  data () {
    return {
      autoid: this.$route.query.autoid,
      title: this.$route.query.title,
      news: {},
    }
  },
  created () {
    this.title = this.$route.query.title
    getScanEntryHomeSet().then(res => {
      const data = res.data[0]
      // 修改页面标题
      document.title = data.home_m_title
    })
    this.getNewsDetails()
  },
  methods: {
    onClickLeft () {
      this.$router.push('/home')
    },
    getNewsDetails () {
      this.autoid = this.$route.query.autoid
      getNewsInfo({
        autoid: this.autoid,
        username: 'admin'
      }).then(res => {
        console.log(res, 'resresres');
        this.news = res.data[0];
        let dom = this.$refs.newHtml;
        this.$nextTick(() => {
          dom.addEventListener("click", (e) => {
            let str = e.srcElement.toString()
            if (str.indexOf("HTMLImageElement") != -1)
            {
              let src = e.srcElement.currentSrc;
              ImagePreview([src]);
            }

          })
        })
      })
    }

  }
}
</script>

<style lang="less" scoped>
.myNewsDetails {
  height: 100vh;
  overflow: hidden;
  .van-nav-bar {
    background: #2b8df0;

    /deep/ .van-nav-bar__left {
      .van-icon {
        color: #fff;
      }
    }
    /deep/.van-nav-bar__title {
      color: #fff;
      font-size: 36px;
      font-family: Source Han Sans CN;
    }
  }
  .content {
    overflow: auto;
    margin-top: 1.22667rem;
    height: calc(100% - 92px);
    .title {
      padding: 20px;
      .name {
        padding: 30px 0;
        font-size: 36px;
        font-weight: 500;
        text-align: center;
      }
      .desc {
        display: flex;
        justify-content: space-between;
        font-size: 24px;
        color: #999999;
      }
    }
    .newHtml {
      padding: 30px;
      p {
        line-height: 1.5 !important;
      }
    }
  }
}
</style>